// extracted by mini-css-extract-plugin
export default {"mainContainer":"Modal_mainContainer__55iXr","modalBox":"Modal_modalBox__BuiJ6","closeButton":"Modal_closeButton__AfYEC"};